import Box from '@mui/material/Box';

type Props = {
  count: number;
  max?: number;
};

// Rounded unread counter pill (chat list rows, sidebar nav item).
export function UnreadBadge({ count, max = 99 }: Props) {
  if (count <= 0) return null;

  return (
    <Box
      component="span"
      sx={{
        flexShrink: 0,
        minWidth: 20,
        height: 20,
        px: count > 9 ? 0.75 : 0,
        borderRadius: 1.25,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        typography: 'caption',
        fontWeight: 'fontWeightBold',
      }}
    >
      {count > max ? `${max}+` : count}
    </Box>
  );
}
